import { AxiosError } from 'axios';
import instance from '../config/axios';

export async function updateEmailNotificationStatus(
  token: string,
  taskExecutionId: string,
) {
  try {
    const response = await instance({
      method: 'POST',
      url: `/api/v1/bulk-email/update/status`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: { taskExecutionId },
    });

    return response.data.message;
  } catch (e) {
    console.log(e);
    return (e as AxiosError).response!.status;
  }
}
